<mat-form-field appearance="standard">
    <mat-label>{{ label }}
        <span class="form-field__req" *ngIf="required">*</span>
    </mat-label>
    <textarea matInput class="" [value]="value" [placeholder]="placeholder || ''" [disabled]="isDisabled ? true : null" (keyup)="onKeyup($event.target.value)" (blur)="onBlur()" [rows]="rows">
    </textarea>
    <mat-hint>{{ remainingChars }} (characters remaining) of {{ messageLength || 1 }} (sms)</mat-hint>
    <!-- <mat-error>
    </mat-error> -->
</mat-form-field>
<div class="form-field__error" [class.form-field_error]="hasError()">
    <ng-container *ngIf="control && errorKey" [ngSwitch]="errorKey">
        <span *ngSwitchCase="'min'">Minimum {{control?.errors[errorKey].min}}</span>
        <span *ngSwitchCase="'max'">Maximum {{control?.errors[errorKey].max}}</span>
        <span *ngSwitchCase="'required'">This field is <strong>required</strong></span>
        <span *ngSwitchCase="'requiredtrue'">This field is <strong>required</strong></span>
        <span *ngSwitchCase="'minlength'">At least {{control?.errors[errorKey].requiredLength}} character</span>
        <span *ngSwitchCase="'maxlength'">No more than {{control?.errors[errorKey].requiredLength}} character</span>
        <span *ngSwitchCase="'pattern'">
            <span *ngIf="patternError">{{patternError}}</span>
        <span *ngIf="!patternError">Pattern dose not match</span>
        </span>
        <span *ngSwitchCase="'min'"></span>
    </ng-container>
</div>
